import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const html = document.documentElement;
    const reset = () => {
      window.__lenis?.scrollTo(0, { immediate: true, force: true });
      window.scrollTo(0, 0);
      html.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    const prevOverflow = html.style.overflow;
    html.style.overflow = "hidden";
    reset();
    const raf = requestAnimationFrame(() => { html.style.overflow = prevOverflow; reset(); });
    const timers = [80, 200, 400, 650].map((ms) => setTimeout(reset, ms));
    return () => { cancelAnimationFrame(raf); timers.forEach(clearTimeout); html.style.overflow = prevOverflow; };
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    const unstick = () => { if (!document.hidden) document.body.style.pointerEvents = ""; };
    document.addEventListener("visibilitychange", unstick);
    window.addEventListener("pageshow", unstick);
    return () => {
      cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null;
      document.removeEventListener("visibilitychange", unstick);
      window.removeEventListener("pageshow", unstick);
    };
  }, []);
  return null;
}

function Layout({ children }) {
  return (
    <div className="App relative bg-bone">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <SmoothScroll />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/services/:path" element={<Layout><ServiceDetail /></Layout>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
      <Toaster position="top-center" richColors />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
